'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _typeof = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

var interpolateParams = function interpolateParams(text, params) {
  if (!params) {
    return text;
  }

  var children = text.split(/({[^}]+})/g).map(function (child) {
    var match = /{(.+)}/g.exec(child);

    if (match) {
      var param = params[match[1]];
      return param ? param : String(param);
    }

    return child;
  });
  return children.some(function (child) {
    return child && (typeof child === 'undefined' ? 'undefined' : _typeof(child)) === 'object';
  }) ? _react2.default.createElement.apply(_react2.default, ['span', null].concat(_toConsumableArray(children))) : children.join('');
};

var getLangMessages = function getLangMessages(translations, lang) {
  var langMessages = translations[lang];

  if (langMessages === undefined && lang.indexOf('-') > -1) {
    langMessages = translations[lang.split('-')[0]];
  }

  return langMessages;
};

var getOptionValue = function getOptionValue(options, key, defaultValue) {
  if (options === undefined) {
    return defaultValue || null;
  }

  return options[key] === undefined ? defaultValue || null : options[key];
};

exports.default = function (translations, lang, fallbackLang) {
  var langMessages = getLangMessages(translations, lang);
  var fallbackLangMessages = fallbackLang ? getLangMessages(translations, fallbackLang) : undefined;
  var plural_rule = getOptionValue(translations.options, 'plural_rule', 'n != 1');
  var plural_number = parseInt(getOptionValue(translations.options, 'plural_number', '2'), 10);
  var suppress_warnings = getOptionValue(translations.options, 'suppress_warnings', false);
  return function (textKey, params, comment) {
    if ((typeof textKey === 'undefined' ? 'undefined' : _typeof(textKey)) === 'object') {
      textKey = textKey[Number(new Function('n', 'return ' + plural_rule)(params[textKey[plural_number]]))];
    }

    if (!langMessages && !fallbackLangMessages) {
      return interpolateParams(textKey, params);
    }

    var message = langMessages ? langMessages[textKey] : undefined;

    if (message === undefined || message === '') {
      if (!suppress_warnings) {
        console.warn('Missing translation for id ' + textKey + ' in language ' + lang);
      }

      if (fallbackLangMessages) {
        var literal = fallbackLangMessages[textKey];

        if (literal !== undefined && literal !== '') {
          return interpolateParams(literal, params);
        }
      }

      return interpolateParams(textKey, params);
    }

    return interpolateParams(message, params);
  };
};